import React from 'react';
import { Navigate } from 'react-router-dom';
import JsUtils from './jsMethods/JsUtils'
import RootConfig from './../main/page/root_page/RootConfig'
const routeConfigs = [
    RootConfig,
];

const routes = [
    ...JsUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path: '/',
        component: () => < Navigate to="/" />
    }
];

export default routes;